import {useAppContext} from "./useAppContext";
import {isMobile} from "react-device-detect";
import {ProductVariablesType} from "../definitions/types";
import {useEffect, useState} from "react";

export const useProductVariables = () => {
    const {productId, currencyCode} = useAppContext();
    const [variables, setVariables] = useState<ProductVariablesType>({
        productId,
        currencyCode,
        isMobile
    });

    useEffect(() => {
        // If the variables have not changed, do nothing
        if (variables.productId === productId && variables.currencyCode === currencyCode && variables.isMobile === isMobile) return;

        // Update the variables
        setVariables({productId, currencyCode, isMobile});
    }, [productId, currencyCode, isMobile]);

    return {variables};
};